import { Router, CanActivate } from '@angular/router'
import { Injectable } from '@angular/core'

import { AuthService } from '@@services/auth.service'
import { GeneralService } from '@@services/general.service'
import { LOCAL_STORAG_KEYS } from '@@constants/local-storage-keys'
import { CUSTOM_EVENTS } from '@@constants/custom-events'

@Injectable()
export class IsLoggedIn implements CanActivate {
    constructor(
        private router: Router,
        private authService: AuthService
    ) {}

    canActivate(): Promise<boolean> {
        return this.authService.isAuthenticated().then((isAuth) => {
            if (!isAuth) {
                this.router.navigateByUrl('/portal/access/login').catch((err) => {
                    console.error(err)
                })
                return false
            }
            return true
        })
    }

    async resolve() {
        if (this.authService.tokenExistsButNoTenantTagsMap()) {
            await this.authService.signInWithToken().subscribe({
                next: (res) => {
                    localStorage.setItem(
                        LOCAL_STORAG_KEYS.IN2_USER_TOKEN,
                        res.token
                    )
                    GeneralService.customEvent.emit(CUSTOM_EVENTS.TOKEN_CHANGED)
                    localStorage.setItem(
                        LOCAL_STORAG_KEYS.USER_NAME,
                        res.profile.name
                    )
                    localStorage.setItem(
                        LOCAL_STORAG_KEYS.USER_IMAGE,
                        res.profile.picUrl
                    )
                    res.profile.token = res.token
                    localStorage.setItem(
                        LOCAL_STORAG_KEYS.USER_EMAIL,
                        res.profile.email
                    )

                    localStorage.setItem(
                        LOCAL_STORAG_KEYS.USER_ID,
                        res.profile.id
                    )

                    this.authService.isAuthenticated().then((isAuth) => {
                        if (!isAuth)
                            this.router
                                .navigateByUrl('/portal/access/login')
                                .catch((err) => {
                                    console.error(err)
                                })
                    })
                },
                error: (error) => {
                    this.authService.isAuthenticated().then((isAuth) => {
                        if (!isAuth)
                            this.router
                                .navigateByUrl('/portal/access/login')
                                .catch((err) => {
                                    console.error(err)
                                })
                    })
                }
            })
        } else {
            await this.authService.isAuthenticated().then((isAuth) => {
                if (!isAuth)
                    this.router
                        .navigateByUrl('/portal/access/login')
                        .catch((err) => {
                            console.error(err)
                        })
            })
        }
    }
}
